import React from 'react';

export const slides = [
  // Slide 1 - AboutSectionData
  {
    content: (
      <div>
        {[
          {
            title: 'Buy today, pay comfortably over time',
            icon: '/images/trolley.svg',
          },
          {
            title: 'Flexible installment options to suit your needs',
            icon: '/images/installment.svg',
          },
          {
            title: 'Pay a small upfront amount to get started',
            icon: '/images/upfront.svg',
          },
          {
            title: 'Access a wide selection of quality products',
            icon: '/images/badge.svg',
          },
          { title: 'Vetted vendors', icon: '/images/shield.svg' },
          {
            title: 'Enjoy instant delivery on all your orders',
            icon: '/images/express-delivery.svg',
          },
        ].map((item, index) => (
          <div key={index} className="flex items-center space-x-6 mb-3">
            <img src={item.icon} alt={item.title} className="w-6 h-6" />
            <p className="text-base font-semibold">{item.title}</p>
          </div>
        ))}
      </div>
    ),
  },

  // Slide 2 - Comparison Table
  // {
  //   content: (
  //     <div>
  //       <div className="flex justify-end items-center space-x-3 mb-4 lg:mt-[-10px]">
  //         <div className="flex items-center space-x-2">
  //           <img
  //             src="/images/SmallSmall-logo.svg"
  //             alt="SmallSmall"
  //             className="h-6 lg:h-8"
  //           />
  //         </div>
  //         <p className="font-bold text-sm lg:text-lg">Others</p>
  //       </div>
  //       <hr className="border border-[#222224] my-4" />
  //       {[
  //         'Lorem ipsum dolor sit amet',
  //         'Lorem ipsum dolor sit amet',
  //         'Lorem ipsum dolor sit amet',
  //         'Lorem ipsum dolor sit amet',
  //       ].map((text, index) => (
  //         <div key={index} className="flex justify-between items-center mb-2">
  //           <p className="  text-lg">{text}</p>
  //           <div className="flex space-x-6 lg:space-x-16 pr-4">
  //             <img
  //               src="/images/check-unfilled.svg"
  //               alt="check"
  //               className="h-5 lg:h-6"
  //             />
  //             <img
  //               src="/images/cancelled.svg"
  //               alt="cancel"
  //               className="h-5 lg:h-6"
  //             />
  //           </div>
  //         </div>
  //       ))}
  //     </div>
  //   ),
  // },

  // Slide 3 - WhatWeDoDifferentlyData
  // {
  //   content: (
  //     <div>
  //       {[
  //         { title: 'Lorem ipsum dolor sit amet' },
  //         { title: 'Lorem ipsum dolor sit amet' },
  //         { title: 'Lorem ipsum dolor sit amet' },
  //         { title: 'Lorem ipsum dolor sit amet' },
  //       ].map((item, index) => (
  //         <p key={index} className="text-lg   font-medium mb-2">
  //           {item.title}
  //         </p>
  //       ))}
  //     </div>
  //   ),
  // },
];
